import FormalEducationTemplate from '../components/education/FormalEducationTemplate';
import ContinuingEducationTemplate from '../components/education/ContinuingEducationTemplate';
import TrainingCertification from '../components/education/TrainingCertification';
import SkillsTemplate from '../components/education/SkillsTemplate';

export const EducationSteps = [
  {
    key: 'formaleducation',
    label: 'Education_Title',
    isValid: true,
    StepComponent: FormalEducationTemplate,
  },
  {
    key: 'continuingeducation',
    label: 'Continuing_Education',
    isValid: true,
    StepComponent: ContinuingEducationTemplate,
  },
  {
    key: 'trainingcertification',
    label: 'Training_Certification_Title',
    isValid: true,
    StepComponent: TrainingCertification,
  },
  {
    key: 'skills',
    label: 'Skills_Title',
    isValid: true,
    StepComponent: SkillsTemplate,
  },
];
